import { z } from 'zod';

export const emailValidationMessages = {
  invalid: 'Enter a valid email (example@example.com)',
  required: 'Required',
};

export const emailSchema = z
  .email({ error: emailValidationMessages.invalid })
  .min(1, { error: emailValidationMessages.required });
